export default __webpack_public_path__ + "616273f298ed69433500b990b46ee551.svg";